import { teethSelectionStore } from "../store/teethSelectionStore";

const useTeethSelectionStore = () => {
  const startStop = teethSelectionStore((state) => state.startStop);
  const initialStartStop = teethSelectionStore((state) => state.initialStartStop);
  const setStartStop = teethSelectionStore((state) => state.setStartStop);

  const endStop = teethSelectionStore((state) => state.endStop);
  const initialEndStop = teethSelectionStore((state) => state.initialEndStop);
  const setEndStop = teethSelectionStore((state) => state.setEndStop);

  const reset = teethSelectionStore((state) => state.reset);

  return {
    startStop,
    initialStartStop,
    setStartStop,
    endStop,
    initialEndStop,
    setEndStop,
    reset,
  };
};

export default useTeethSelectionStore;
